(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart__main_vouchers"]) return;
  try {
    
let voucher_code_input = document.getElementById("voucher_code");
const base_url = "https://www.lifeofcolourproducts.com";
let timeout = null;

voucher_code_input.addEventListener("input", async (e) => {

    clearTimeout(timeout);

    timeout = setTimeout(async () => {
        let voucher_code = e.target.value;
        let voucher_response = document.getElementById("voucher_response");

        if(voucher_code.length >= 8)
        {
            const validate_path = `apps/nswvoucher/api/validate/${voucher_code}`;
            let validate_url = [base_url, validate_path].join('/');

            addLoadingAnimation(e);

            let voucher_valid = await fetch(validate_url).then((response) => response.json());

            if(document.getElementById("voucher-message"))
                document.getElementById("voucher-message").remove();

            if (voucher_valid.balance)
            {
                setVoucherList(voucher_code);

                if(!document.getElementById("redeem-button"))
                {
                    voucher_response.innerHTML = "<strong>Validated vouchers:</strong>";
                    let voucher_list = document.getElementById("voucher_list");
                    voucher_list.insertAdjacentHTML("afterend", "<button type='button' class='button button--primary click-btn' id='redeem-button'>Redeem vouchers</button>");

                }

                e.target.value = "";
                deleteLoadingAnimation();
            }
            else if (voucher_valid.error)
            {
                e.target.parentNode.insertBefore(addMessageToInput(voucher_valid.message), e.target.nextSibling);
                deleteLoadingAnimation();
            }
        }
    });
}, false);

let redeem_button_parent = document.getElementById("voucher_response");

jQuery("body").on("click", "#redeem-button", async (e) => {
    let vouchers = document.querySelectorAll("input[name='voucher_inputs[]']");
    let customer = {};
    customer['name'] = document.querySelector("#voucher_person_name").value;
    customer['email'] = document.querySelector("#voucher_person_email").value;

    let vouchers_codes = [];

    let cart_response = await fetch("/cart.json?currency=AUD").then((response) => response.json());

    Array.from(vouchers).map(voucher => vouchers_codes.push(voucher.value));

    let redeem_path = `apps/nswvoucher/api/bulk/redeem?vouchers=${vouchers_codes.join("|")}`;
    let redeem_url = [base_url, redeem_path].join("/");

    let metadata = {}
    metadata['locationName'] = "Life Of Colour";
    metadata['locationSuburb'] = "New South Wales";
    metadata['locationPostcode'] = 2029;

    for(var i = 1; i <= cart_response.item_count; i++)
    {
      var j = i - 1;
      //metadata[`itemCategory${i}`] = result.items[j].title,
      //metadata[`itemCategory${i}`] = "Other stationery";
      metadata[`itemValue${i}`] = cart_response.items[j].price;
    }

    let post_body = JSON.stringify({
        'total_price' : cart_response.total_price,
        'metadata' : metadata,
        'customer' : customer
    });

    fetch(redeem_url, {
        method: 'POST',
        headers: {
        'Content-Type' : 'application/json'
        },
        body: post_body
    })
    .then((response) => response.json())
    .then((data) => {
        let cartForm = document.getElementById("cart_form");
        let cartFormAction = cartForm.getAttribute("action");
        cartForm.setAttribute("action", cartFormAction + `?discount=${data.voucher_code}`);
        let loc_bts_voucher = document.querySelector(".loc_bts_voucher");
        loc_bts_voucher.innerHTML = `<div id='voucher_response'><span class='success'>Congratulations! <strong>$${data.total_discount}</strong> will be discounted from your purchase during checkout, <strong>please click the Checkout button to continue</strong>.</span>\
        <span class='void'>If you made a mistake, you can <a id="void-redemption">cancel the redemption</a> (it will cancel the discount and reinstate your vouchers).</span></div>`;

        let transactionCount = data.voucher_response.length;
        let voucherResponse = document.getElementById("voucher_response");

        for(var i = 0; i < transactionCount; i++)
        {
          voucherResponse.insertAdjacentHTML('beforeend', `<input type='hidden' name='transactions_ids[]' value='${data.voucher_response[i].transactionCode}'>`);
        }
    });
});

jQuery("body").on("click", ".remove-voucher", (e) => {
    e.target.parentNode.remove();
});

jQuery("body").on("click", "#void-redemption", async (e) => {
  e.preventDefault();
  let transactions_ids = document.querySelectorAll("input[name='transactions_ids[]'");
  let transactions = [];
  Array.from(transactions_ids).map(transaction_id => transactions.push(transaction_id.value));

  let transaction_path = `apps/nswvoucher/api/bulk/void?transactions=${transactions.join("|")}`;
  let transaction_url = [base_url, transaction_path].join("/");

  let transactions_response = await fetch(transaction_url).then((response) => response.json());

  if (transactions_response == "VOID")
  {
    let loc_bts_voucher = document.querySelector(".loc_bts_voucher");
    loc_bts_voucher.innerHTML = "<div id='voucher_response'>The vouchers have been reinstated.</div>"
  }
});

function setVoucherList(voucher_code)
{
    let container = document.getElementById("voucher_list");
    let remove_voucher = document.createElement("div");
    remove_voucher.setAttribute("class", "remove-voucher");
    let container_div = document.createElement("div");
    container_div.setAttribute("class", "voucher-list voucher-ok");
    let input_hidden = document.createElement("input");
    input_hidden.setAttribute("type", "hidden");
    input_hidden.setAttribute("name", "voucher_inputs[]");
    input_hidden.setAttribute("value", voucher_code);
    container_div.innerText = voucher_code;
    container_div.appendChild(input_hidden);
    container_div.appendChild(remove_voucher);
    container.appendChild(container_div);
}

function addMessageToInput(message)
{
    var parent = document.createElement("div");
    parent.setAttribute("id", "voucher-message");
    parent.innerHTML = message;
    return parent;
}

function addLoadingAnimation(e)
{
    var loading_parent = document.createElement("div");
    loading_parent.setAttribute("id", "loading-input");
    var loading_circle = document.createElement("div");
    loading_circle.setAttribute("class", "loading-circle");
    var loading_child = document.createElement("div");
    loading_circle.appendChild(loading_child);
    loading_parent.appendChild(loading_circle);
    e.target.parentNode.insertBefore(loading_parent, e.target.nextSibling);
}

function deleteLoadingAnimation()
{
    var loading = document.getElementById("loading-input");
    loading.remove();
}

  } catch(e) { console.error(e); }
})();
})();
